import { ConfigurationFieldStatus } from './configurationField';

// RTK Query status flags interface
export interface RequestStatusFlags {
  isUninitialized: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

export const rtkQueryPatchStatusToConfigurationFieldStatus = (
  patchConfigurationStatus: RequestStatusFlags,
): ConfigurationFieldStatus => {
  if (patchConfigurationStatus.isUninitialized) {
    return ConfigurationFieldStatus.DEFAULT;
  } else if (patchConfigurationStatus.isLoading) {
    return ConfigurationFieldStatus.LOADING;
  } else if (patchConfigurationStatus.isSuccess) {
    return ConfigurationFieldStatus.SUCCESS;
  } else {
    // if all previous conditions are false, then isError is true
    return ConfigurationFieldStatus.ERROR;
  }
};
